var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useMemo } from 'react';
import { FormControl, IconButton, InputLabel, OutlinedInput } from '@material-ui/core';
import { mdiMinus, mdiPlus } from '@mdi/js';
import Icon from '@mdi/react';
import styled from 'styled-components';
import { IconSize } from '../../lib';
const StyledFormControl = styled(FormControl) `
    .MuiOutlinedInput-adornedStart {
        padding-left: 5px;
    }
    .MuiOutlinedInput-adornedEnd {
        padding-right: 5px;
    }
`;
const StyledInputLabel = styled(InputLabel) `
    margin-top: -7px;
    margin-left: 13px;
`;
const StyledOutlinedInput = styled(OutlinedInput) `
    // Workaround weird margins that don't line up with other TextFields on the same row.
    ${(props) => (props.margin === 'dense' ? 'margin-bottom: -3px;' : null)}

    input {
        text-align: center;
    }
`;
const StyledIconButton = styled(IconButton) `
    svg {
        width: ${(props) => props.iconSize};
        color: ${(props) => (props.disabled ? props.theme.colors.border : props.theme.colors.primary)};
    }
`;
const Counter = (_a) => {
    var { label, setValue, value, minimum, maximum, margin, width } = _a, rest = __rest(_a, ["label", "setValue", "value", "minimum", "maximum", "margin", "width"]);
    const canIncrement = useMemo(() => {
        if (maximum === undefined) {
            return true;
        }
        return value < maximum;
    }, [maximum, value]);
    const canDecrement = useMemo(() => {
        if (minimum === undefined) {
            return true;
        }
        return value > minimum;
    }, [minimum, value]);
    const setClampedValue = useCallback((int) => {
        if (isFinite(int)) {
            if (maximum !== undefined && int > maximum) {
                setValue(maximum);
                return;
            }
            if (minimum !== undefined && int < minimum) {
                setValue(minimum);
                return;
            }
            setValue(int);
        }
        else {
            setValue(minimum !== null && minimum !== void 0 ? minimum : 0);
        }
    }, [minimum, maximum, setValue]);
    const handleIncrement = () => {
        setClampedValue(value + 1);
    };
    const handleDecrement = () => {
        setClampedValue(value - 1);
    };
    const handleChange = (event) => {
        const int = parseInt(event.target.value);
        // Don't use setClampedValue here so manual user input is unconstrained (besides non-finite values).
        // onBlur, the input will be clamped to [min, max].
        if (isFinite(int)) {
            setValue(int);
        }
        else {
            setValue(0);
        }
    };
    const handleBlur = (event) => {
        const int = parseInt(event.target.value);
        setClampedValue(int);
    };
    return (React.createElement(StyledFormControl, Object.assign({ "aria-label": "counter", style: { width } }, rest),
        React.createElement(StyledInputLabel, null, label),
        React.createElement(StyledOutlinedInput, { name: "content", "aria-label": label, "data-testid": "Counter-outlined-input", value: value, onChange: handleChange, onBlur: handleBlur, inputProps: {
                inputMode: 'numeric',
                pattern: '[0-9]*',
                'aria-label': `${label} input`,
                'data-testid': 'Counter-outlined-input-input'
            }, label: label, notched: true, margin: margin, startAdornment: React.createElement(StyledIconButton, { "aria-label": "subtract", "data-testid": "Counter-subtract-button", onClick: handleDecrement, iconSize: IconSize.Small, disabled: !canDecrement },
                React.createElement(Icon, { path: mdiMinus })), endAdornment: React.createElement(StyledIconButton, { "aria-label": "add", "data-testid": "Counter-add-button", onClick: handleIncrement, iconSize: IconSize.Small, disabled: !canIncrement },
                React.createElement(Icon, { path: mdiPlus })) })));
};
export default Counter;
//# sourceMappingURL=Counter.js.map